export default __webpack_public_path__ + "static/media/024-diving-helmet.42083af1.png";